// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import FireDepartmentModel from '../../model/fire-department-model';
import FireDepartmentDTO from '../dto/fire-department-dto';
import dtoSchema from '../schemas/fire-department-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class FireDepartmentModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<FireDepartmentDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.logoId = data.logoId;
      this.name = data.name;
      this.abbreviation = data.abbreviation;
      this.lat = data.lat;
      this.lng = data.lng;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @type {int64}
  */
  logoId?: number;
  /**
  * @minimum 1
  */
  name?: string;
  /**
  * @minimum 1
  */
  abbreviation?: string;
  /**
  * @type {float}
  */
  lat?: number;
  /**
  * @type {float}
  */
  lng?: number;

  static toModel(dto: DeepPartial<FireDepartmentDTO>): FireDepartmentModel;
  static toModel(dto: DeepPartial<FireDepartmentDTO> | undefined | null): FireDepartmentModel | undefined;
  static toModel(dto: DeepPartial<FireDepartmentDTO> | undefined | null): FireDepartmentModel | undefined {
    return dto ? new FireDepartmentModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<FireDepartmentModel> | FireDepartmentModel): FireDepartmentDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      logoId: unwrapped.logoId,
      name: unwrapped.name,
      abbreviation: unwrapped.abbreviation,
      lat: unwrapped.lat,
      lng: unwrapped.lng,
    } as FireDepartmentDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for FireDepartmentModel, can not map to FireDepartmentDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
